export default {
  vgn: {
    name: 'Wegańskie',
    emoji: '🌱',
  },
  vgt: {
    name: 'Wegetariańskie',
    emoji: '🥬',
  },
  gf: {
    name: 'Bez glutenu',
  },
  df: {
    name: 'Bez nabiału',
  },
  hal: {
    name: 'Halal',
  },
  'h&s': {
    name: 'Ostre',
    emoji: '🌶',
  },
};
